import React from 'react';
import { CheckIcon } from 'lucide-react';
import { SectionHeading } from '../ui/SectionHeading';
import { Reveal } from '../ui/Reveal';
import { FACILITADORAS } from '../../data/retiro';
export function Facilitadoras() {
  return <section id="facilitadoras" className="w-full px-5 py-24 sm:px-8 sm:py-32" data-id="element-127" data-mp="pnfs140shy5n">
      <div className="mx-auto max-w-6xl" data-id="element-128" data-mp="ufzekqhgg3ml">
        <SectionHeading eyebrow="Quién sostiene el contenedor" title="Anfitriona y guía de esta experiencia" data-id="element-129" data-mp="uh0rz1ly127h" />

        <div className="mt-16 flex flex-col gap-8" data-id="element-130" data-mp="13f2whr4vyczi">
          {FACILITADORAS.map((f, i) => <Reveal key={f.nombre} delay={i * 0.05} data-id="element-131" data-mp="18e778m7gkiry" data-mpi={i}>
              <article className="rounded-[2rem] border p-8 sm:p-10" style={{
            borderColor: 'rgba(42,36,32,0.1)',
            backgroundColor: 'white'
          }} data-id="element-132" data-mp="18fi74axs96ds">
                <div className="grid gap-8 md:grid-cols-[auto,1fr]" data-id="element-133" data-mp="3f4n3jswhgydi">
                  <div className="flex items-center gap-5 md:w-56 md:flex-col md:items-start md:gap-4" data-id="element-134" data-mp="3f6zuuwo4sl38">
                    <div className="flex h-20 w-20 shrink-0 items-center justify-center rounded-full text-3xl" style={{
                  backgroundColor: f.acento
                }} data-id="element-135" data-mp="2f2xrq3nqgc7k">
                      {f.emoji}
                    </div>
                    <div data-id="element-136" data-mp="2xzpdqkunt5fb">
                      <h3 className="font-heading text-2xl font-light" style={{
                    color: 'var(--ink)'
                  }} data-id="element-137" data-mp="2xywcfzegz84k">
                        {f.nombre}
                      </h3>
                      <p className="text-sm" style={{
                    color: f.acento
                  }} data-id="element-138" data-mp="2k0zcct0t4jl5">
                        {f.rol}
                      </p>
                    </div>
                  </div>

                  <div data-id="element-139" data-mp="1a3800rgwneta">
                    <blockquote className="border-l-2 pl-5 font-heading text-base font-light italic leading-relaxed" style={{
                  borderColor: f.acento,
                  color: 'var(--ink)'
                }} data-id="element-140" data-mp="1a2pu134fxm86">
                      "{f.cita}"
                    </blockquote>

                    <div className="mt-5 space-y-3" data-id="element-141" data-mp="ranlyg5v7e9j">
                      {f.parrafos.map((p, idx) => <p key={idx} className="text-sm leading-relaxed" style={{
                    color: 'rgba(42,36,32,0.72)'
                  }} data-id="element-142" data-mp="w370bfcdmdfe" data-mpi={idx}>
                          {p}
                        </p>)}
                    </div>

                    {f.lista && <div className="mt-6" data-id="element-143" data-mp="db4elpkvo6ya">
                        <p className="mb-3 text-xs font-medium uppercase tracking-[0.2em]" style={{
                    color: f.acento
                  }} data-id="element-144" data-mp="3pv9sml2ioqpv">
                          {f.lista.titulo}
                        </p>
                        <ul className="grid gap-2 sm:grid-cols-2" data-id="element-145" data-mp="3utjqx4jjg7fp">
                          {f.lista.items.map(item => <li key={item} className="flex items-start gap-2 text-sm" style={{
                      color: 'rgba(42,36,32,0.78)'
                    }} data-id="element-146" data-mp="cnf26qyhq0ly">
                              <CheckIcon className="mt-0.5 h-4 w-4 shrink-0" style={{
                        color: f.acento
                      }} data-id="element-147" data-mp="hht5rgnb3e1p" />
                              <span data-id="element-148" data-mp="2kvtraxknc2ht">{item}</span>
                            </li>)}
                        </ul>
                      </div>}
                  </div>
                </div>
              </article>
            </Reveal>)}
        </div>
      </div>
    </section>;
}